import { Component, Input } from '@angular/core';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { WebSuccessMetrics } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';

@Component({
    selector: 'pk-web-success-metrics',
    templateUrl: './success-metrics.component.html',
    styleUrl: './success-metrics.component.scss',
    standalone: false
})
export class SuccessMetricsComponent extends AbstractPageForm {
	@Input() showSatisfiedCustomers = true;
	@Input() showAssetsUnderManagement = true;
	@Input() showYearsInBusiness = true;

	public yearsInBusiness: number;
	public webSuccessMetrics: WebSuccessMetrics;

	constructor(private graphqlService: GraphqlService) {
		super();
	}

	public override async loadPageData(): Promise<void> {
		this.yearsInBusiness = new Date().getFullYear() - 2013;

		// Only fetch GraphQL data if we need to show metrics that require it
		if (this.showSatisfiedCustomers || this.showAssetsUnderManagement) {
			const result = await this.graphqlService.query<{
				webSuccessMetrics: WebSuccessMetrics;
			}>(`
				query GetWebSuccessMetrics {
					webSuccessMetrics {
						totalKwhs
						totalTherms
						totalSatisfiedCustomers
					}
				}
			`);

			this.webSuccessMetrics = result.data.webSuccessMetrics;
		}
	}
}
